import React, {useContext} from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import {FirebaseContext} from '../firebase'
import {LinkContainer} from 'react-router-bootstrap'

function Header(props) {
    const {user} = useContext(FirebaseContext)
    return (
        <Navbar bg="light" expand="md" sticky="top">
            <LinkContainer to="/">
                <Navbar.Brand>React-Sequences</Navbar.Brand>
            </LinkContainer>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
            <LinkContainer to="/">
                <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            {user && (
            <LinkContainer to="/create/sequence"> 
                <Nav.Link>Create a Sequence</Nav.Link>
            </LinkContainer>
            )}
            </Nav>
            {user?
                <SignedIn email={user.email} logout={props.logout}/>:
                <LinkContainer to="/login"> 
                    <Nav.Link className="pl-0">Login/Sign-up</Nav.Link>
                </LinkContainer>
            }
            </Navbar.Collapse>
        </Navbar>
    )
}

function SignedIn(props) {
    return (
        props.email? 
        <NavDropdown title={"Signed in as: " + props.email} id="basic-nav-dropdown">
            <LinkContainer to="/profile"> 
                <NavDropdown.Item>Your Sequences</NavDropdown.Item>
            </LinkContainer>
            <NavDropdown.Item onClick={props.logout}>Sign out</NavDropdown.Item>
        </NavDropdown>:
        null
    )
}

export default Header